import { httpRequest } from '@/utils/umiRequest';
import { Log } from './index.d';



//  获取日志列表 /api/admin/saas-dispute/operate-log/{ticket_id}
export const getLogList = async (ticket_id: string | number): Promise<Log[]> => {
  return await httpRequest.get(`/saas-dispute/operate-log/${ticket_id}`);
};
